export enum StatusAtivoEnum {
  NAO_INFORMADO,
  ATIVO,
  INATIVO,
}

// Mapeamento para exibição amigável
export const StatusAtivoLabels: Record<StatusAtivoEnum, string> = {
  [StatusAtivoEnum.NAO_INFORMADO]: 'Não informado',
  [StatusAtivoEnum.ATIVO]: 'Sim',
  [StatusAtivoEnum.INATIVO]: 'Não',
};

// Mapeamento para códigos/slugs (se necessário para URLs, etc.)
export const StatusAtivoCodes: Record<StatusAtivoEnum, string> = {
  [StatusAtivoEnum.NAO_INFORMADO]: 'NI',
  [StatusAtivoEnum.ATIVO]: 'S',
  [StatusAtivoEnum.INATIVO]: 'N',
};

export const getStatusAtivoOptions = () => {
  return Object.values(StatusAtivoEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as StatusAtivoEnum,
      label: StatusAtivoLabels[value as StatusAtivoEnum],
      code: StatusAtivoCodes[value as StatusAtivoEnum],
    }));
};

export const getStatusAtivoLabel = (statusAtivo: StatusAtivoEnum): string => {
  return StatusAtivoLabels[statusAtivo] || 'Status Desconhecido';
};

export const getStatusAtivoSlug = (statusAtivo: StatusAtivoEnum): string => {
  return StatusAtivoCodes[statusAtivo] || 'Desconhecido';
};

export const getStatusAtivoPorCodigo = (
  code: string,
): StatusAtivoEnum | undefined => {
  const entry = Object.entries(StatusAtivoCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as StatusAtivoEnum) : undefined;
};

export const getStatusAtivoSlugPorValue = (value: number | string): string => {
  const numericValue = typeof value === 'string' ? Number(value) : value;
  return StatusAtivoCodes[numericValue as StatusAtivoEnum] || 'Desconhecido';
};

export const getStatusAtivoLabelPorSlug = (slug: string): string => {
  const entry = Object.entries(StatusAtivoCodes).find(
    ([, value]) => value === slug,
  );
  if (entry) {
    const key = Number(entry[0]) as StatusAtivoEnum;
    return StatusAtivoLabels[key] || 'Não informado';
  }
  return 'Não informado';
};
